import { Component, Input } from '@angular/core';
import { Marked, Renderer } from '@ts-stack/markdown';

@Component({ standalone: false, 
  selector: 'cyborg-markdown',
  styleUrls: ['./markdown.component.scss'],
  templateUrl: './markdown.component.html',
})
export class MarkdownComponent {
  public html: string;

  @Input()
  public set md(value: string) {
    Marked.setOptions({
      renderer: new Renderer(),
      gfm: true,
      tables: false,
      breaks: false,
      pedantic: false,
      sanitize: false,
      smartLists: true,
      smartypants: false,
    });
    this.html = Marked.parse(value);
  }
}
